import React from 'react';

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  totalItems,
  itemsPerPage,
}) => {
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Function to generate pagination numbers with ellipsis
  const getPaginationNumbers = () => {
    const pages = [];

    if (totalPages <= 3) {
      // Show all pages if 3 or less
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Check if we're in the last 3 pages
      if (currentPage >= totalPages - 2) {
        // Show last 3 pages without ellipsis (e.g., 6,7,8)
        for (let i = totalPages - 2; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        // Show current page and next page (2 consecutive)
        pages.push(currentPage);
        pages.push(currentPage + 1);
        // Add ellipsis
        pages.push('...');
        // Add last 2 pages
        pages.push(totalPages - 1);
        pages.push(totalPages);
      }
    }

    return pages;
  };

  return (
    <div className='card-footer bg-white border-top py-3 mt-3'>
      <div className='d-flex flex-column flex-sm-row justify-content-between align-items-center gap-2 px-3'>
        <div className='text-muted small text-center text-sm-start'>
          Showing {indexOfFirstItem + 1} to{' '}
          {Math.min(indexOfLastItem, totalItems)} of {totalItems} results
        </div>
        <nav>
          <ul className='pagination pagination-sm mb-0'>
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
              <button
                className='page-link'
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Prev
              </button>
            </li>
            {getPaginationNumbers().map((page, index) => {
              if (page === '...') {
                return (
                  <li key={`ellipsis-${index}`} className='page-item disabled'>
                    <span className='page-link'>...</span>
                  </li>
                );
              }
              return (
                <li
                  key={page}
                  className={`page-item ${
                    currentPage === page ? 'active' : ''
                  }`}
                >
                  <button
                    className='page-link'
                    onClick={() => onPageChange(page)}
                  >
                    {page}
                  </button>
                </li>
              );
            })}
            <li
              className={`page-item ${
                currentPage === totalPages ? 'disabled' : ''
              }`}
            >
              <button
                className='page-link'
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Pagination;
